
import {    ADVANCEREPORT, GETASISTANTPAYROLLREPORT, GETMONTLYGSTDETAILS, GETOVERALLCOUNTERDETAILS, RAWMATERIALRPT, RAWMATERIALRPTXLSX } from "../../../utils/api";
import axios from "../../../utils/axios";
 
// export const getCategorySalesCustomers=async(param)=>{
//     const res=await axios.post(GETCATEGORYWISECOUNTERSALE,param);
//     return res;
// }
export const getMonthlyDetails=async(param)=>{
    const res=await axios.post(RAWMATERIALRPT,param);
    return res;
}

export const getOverallCounterDetail=async(param)=>{
    const res=await axios.post(ADVANCEREPORT,param)
    return res;
}

export const getItemCategoryWiseCounterSaleReportXlsx=async(param,options)=>{
    const res=await axios.post(RAWMATERIALRPTXLSX,param,options)
    return res;
}